import React from "react";
import moment from "moment";

export const PalletsRechazadosTable = ({ numeroPallet }) => {
    const { palletsRechazados, palletRechazado, handleSeleccionar } =
        numeroPallet;

    return (
        <div className="new-table-wrapper mt-3">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Número</th>
                        <th>Producto</th>
                        <th>EVS</th>
                        <th>Turno</th>
                        <th>Fecha</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {palletsRechazados.length === 0 && (
                        <tr>
                            <td colSpan={6} className="text-center">
                                No hay números de pallets rechazados disponibles
                            </td>
                        </tr>
                    )}
                    {palletsRechazados.map((pallet) => {
                        const seleccionado =
                            palletRechazado && palletRechazado.id === pallet.id;

                        return (
                            <tr key={pallet.id}>
                                <td className="text-center text-nowrap">
                                    {pallet.numero}
                                </td>
                                <td className="text-center">
                                    {pallet.producto_terminado_nombre || "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {pallet.evs_numero || "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {pallet.turno_nombre || "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {pallet.fecha_creacion
                                        ? moment(pallet.fecha_creacion).format(
                                              "DD/MM/YYYY HH:mm",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center">
                                    <button
                                        type="button"
                                        className={
                                            seleccionado
                                                ? "btn btn-sm btn-success"
                                                : "btn btn-sm btn-outline-dark"
                                        }
                                        onClick={() =>
                                            handleSeleccionar(pallet)
                                        }
                                    >
                                        {seleccionado
                                            ? "Seleccionado"
                                            : "Reutilizar"}
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
